export enum InvoiceLanguage {
    ENGLISH = 'ENGLISH',
    FINNISH = 'FINNISH',
    SWEDISH = 'SWEDISH',
    ESTONIAN = 'ESTONIAN',
    NORWEGIAN = 'NORWEGIAN',
    DANISH = 'DANISH',
}
